import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import eventHub from './scripts/eventHub';
import './registerServiceWorker';

sync(store, router);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = eventHub;

Object.defineProperty(HTMLElement.prototype, '_splitInstance', {
  value: '',
  configurable: true,
  enumerable: false,
  writable: true,
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
